export default __webpack_public_path__ + "static/media/screen6.fb8a11f9.png";